// Renders an assistant turn as clipboard-ready plain text: intro line, then one
// block per doc answer (context, answer, source title, citation quotes). Shared
// across web and mobile.

import { stripCitationMarkers } from './doc-answer';

/** One doc answer prepared for copy. */
export interface AnswerCopySegment {
  context?: string | null;
  text: string;
  /** Resolved source document title; rendered as `Source: <title>`. */
  sourceName?: string | null;
  /** Plain-text citation quotes; rendered as `- "<quote>"` bullets. */
  citations?: string[];
}

/** Localized labels for the copy text's structural lines. */
export interface AnswerCopyLabels {
  source: string;
  citations: string;
}

export function formatAnswerCopyText(
  intro: string | null | undefined,
  answers: AnswerCopySegment[],
  labels: AnswerCopyLabels,
): string {
  const blocks: string[] = [];
  const trimmedIntro = intro?.trim();
  if (trimmedIntro) blocks.push(trimmedIntro);

  for (const answer of answers) {
    const lines: string[] = [];
    const context = answer.context?.trim();
    const text = stripCitationMarkers(answer.text);
    const sourceName = answer.sourceName?.trim();
    const citations = (answer.citations ?? []).map(quote => quote.trim()).filter(Boolean);
    if (context) lines.push(context);
    if (text) lines.push(text);
    if (sourceName) lines.push(`${labels.source}: ${sourceName}`);
    if (citations.length) {
      lines.push(`${labels.citations}:`);
      lines.push(...citations.map(quote => `- "${quote}"`));
    }
    if (lines.length) blocks.push(lines.join('\n'));
  }

  return blocks.join('\n\n');
}
